import { useState } from 'react';
import { Bullets, Buttons } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { useTranslation } from 'Hooks/useTranslation';
import CustomTransition from 'Components/CustomTransition';
import * as Styled from './styles';

const InfoPlan = ({ service }: { service: string }): JSX.Element => {
  const [viewBullet, setViewBullet] = useState(false);
  const { t } = useTranslation(locizeNS.PLANS);
  const bullets = (): { text: string }[] =>
    Array.from({ length: 3 }, (_, i) => ({
      text: t(`PlanCard.${service}.upselling.${i + 1}`),
    }));
  return (
    <Styled.BulletsContainer direction="column" viewBullet={viewBullet} gap="dimension_16">
      <Buttons.TopNav
        label={t('Plans.more.information')}
        side="NEXT"
        showIcon
        onClick={() => {
          setViewBullet(!viewBullet);
        }}
      />
      {viewBullet && (
        <CustomTransition start>
          <Bullets
            icon={{ type: 'IconTickCleanSGreen', width: 16, height: 16 }}
            spacing="S"
            bullets={bullets()}
          />
        </CustomTransition>
      )}
    </Styled.BulletsContainer>
  );
};

export default InfoPlan;
